import { useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ZohoSetup() {
  const [form, setForm] = useState({ setup_token: "", client_id: "", client_secret: "", authorization_code: "" });
  const [status, setStatus] = useState("");
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setStatus("");
    try {
      await axios.post(`${API}/zoho/setup`, form);
      setStatus("ok");
      setForm({ setup_token: "", client_id: "", client_secret: "", authorization_code: "" });
    } catch (err) {
      setStatus(err.response?.data?.detail || "Connection failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-neutral-950 flex items-center justify-center px-6" data-testid="zoho-setup-page">
      <form onSubmit={submit} className="w-full max-w-sm space-y-4" data-testid="zoho-setup-form">
        <h1 className="text-neutral-300 text-sm tracking-[0.25em] uppercase text-center mb-6">Zoho CRM Authentication</h1>
        {[
          ["setup_token", "Setup Token"],
          ["client_id", "Client ID"],
          ["client_secret", "Client Secret"],
          ["authorization_code", "Authorization Code"],
        ].map(([k, label]) => (
          <input
            key={k}
            data-testid={`zoho-setup-${k.replace(/_/g, "-")}`}
            type="password"
            autoComplete="off"
            required
            value={form[k]}
            onChange={set(k)}
            placeholder={label}
            className="w-full bg-neutral-900 border border-neutral-800 text-neutral-200 text-sm px-4 py-3 focus:outline-none focus:border-amber-200/50"
          />
        ))}
        <button
          data-testid="zoho-setup-submit"
          disabled={busy}
          className="w-full bg-amber-200/90 text-neutral-950 text-sm tracking-[0.2em] uppercase py-3 hover:bg-amber-200 transition-colors disabled:opacity-50"
        >
          {busy ? "Connecting…" : "Connect"}
        </button>
        {status === "ok" && (
          <p data-testid="zoho-setup-success" className="text-emerald-400/90 text-xs text-center pt-2">
            Connected. Credentials stored server-side.
          </p>
        )}
        {status && status !== "ok" && (
          <p data-testid="zoho-setup-error" className="text-red-400/90 text-xs text-center pt-2">{status}</p>
        )}
      </form>
    </div>
  );
}
